import api from "../../Api";
import { BaseService } from "../../BaseService";

const URL = "access/profiles";

export class AccessProfileService extends BaseService {
  async list(params: any): Promise<any[]> {
    try {
      return this.handleResponse(await api.post(`${URL}/list`, params));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async fetch(params: any): Promise<any> {
    try {
      if (params?.id) {
        return this.handleResponse(await api.put(`${URL}/update`, params));
      } else {
        return this.handleResponse(await api.post(`${URL}/create`, params));
      }
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async delete(id: number): Promise<any> {
    try {
      return this.handleResponse(await api.delete(`${URL}/delete/${id}`));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async menu(accessProfileId?: number): Promise<any[]> {
    try {
      if (accessProfileId) {
        return this.handleResponse(
          await api.get(`${URL}/menu?access_profile_id=${accessProfileId}`)
        );
      } else {
        return this.handleResponse(await api.get(`${URL}/menu`));
      }
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async permission(params: any): Promise<any> {
    try {
      return this.handleResponse(await api.post(`${URL}/permission`, params));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async partnerMenu(partnerCode: string): Promise<any[]> {
    try {
      return this.handleResponse(
        await api.get(`${URL}/menu?partner_code=${partnerCode}`)
      );
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async partnerPermission(params: any): Promise<any> {
    try {
      return this.handleResponse(
        await api.post(`${URL}/partner-permission`, params)
      );
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }
}
